import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=566466c0&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('566466c0')) {
      api.createRecord('566466c0', component.options)
    } else {
      api.reload('566466c0', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=566466c0&", function () {
      api.rerender('566466c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/platforms/details/edit.vue"
export default component.exports